import React, { useState, useEffect, useCallback } from 'react';
import MapModal from '../components/MapModal';
import {
    getAllSlot,
    getAllTask,
    getAllCentre,
    getAllClients,
    getAllEmployees,
    creatTask,
    updateOperationTask
} from "../Services/masterService"
import CancelTaskModal from '../components/CancelTaskModal';
import Modal from '../AlertModal/Modal';
import Select from "react-select";
import TaskViewModal from '../components/TaskViewModal';


// Dummy list of available resources for dropdowns
// const mockClients = [{ id: 'CL-001', name: 'City Lab Pvt Ltd' }, { id: 'CL-002', name: 'Health Diagnostics' }];
// const mockSlots = [{ id: 1, time: '09:00 - 11:00' }, { id: 2, time: '11:00 - 13:00' }];
// const mockCentres = [{ id: 'Centre A', name: 'Central Lab A' }, { id: 'Centre B', name: 'Satellite Centre B' }];
// const mockEmployees = [{ id: 'EMP-101', name: 'Rajesh Sharma' }, { id: 'EMP-102', name: 'Priya Singh' }];

// Helper to format ISO date to separate date and time strings
const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const dateStr = date.toISOString().split('T')[0]; // YYYY-MM-DD
    const timeStr = date.toTimeString().substring(0, 5); // HH:MM
    return { dateStr, timeStr };
};


const initialFormState = {
    taskType: "Sample Pickup Request",
    preferredDate: new Date().toISOString().split('T')[0], // YYYY-MM-DD
    slotId: "",
    // createdBy: null,
    pickupClientId: '',
    pickupAddress: "",
    pickupLatitude: 22.5726,
    pickupLongitude: 88.3639,
    dropCentreId: '',
    dropAddress: "",
    dropLatitude: 22.5678,
    dropLongitude: 88.3745,
    assignedTo: '',
    priority: "NORMAL",
    description: "",
    createdByType: "OPERATION",
    createdById: ""
};


// =================================================================
// MAIN TASK SCHEDULER COMPONENT
// =================================================================

function OperationTask() {
    const [taskList, setTaskList] = useState([]);

    const [formData, setFormData] = useState(initialFormState);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [apiMessage, setApiMessage] = useState({ type: '', text: '' });
    const [userInfo, setUserInfo] = useState('unknowne')

    const { preferredDate, preferredTime } = formData;
    const preferredDateTime = new Date(`${preferredDate}T${preferredTime}:00.000Z`);
    const [editingTask, setEditingTask] = useState(null);

    // API Call to Fetch Data
    const fetchTasks = useCallback(async () => {
        setIsLoading(true);
        setApiMessage({ type: '', text: '' });
        const storedUser = localStorage.getItem('user');
        const userInfo = JSON.parse(storedUser)
        try {
            const response = await getAllTask(userInfo.id);
            if (response.status === 1) {
                setTaskList(response.data);
            } else {
                // setApiMessage({ type: 'error', text: 'Failed to fetch task list.' });
                console.log('data not found!')
            }
        } catch (error) {
            setApiMessage({ type: 'error', text: 'Network error occurred while fetching data.' });
        } finally {
            setIsLoading(false);
        }


    }, []);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({});

    const showSuccess = (msg) => {
        setModalConfig({
            title: "Success!",
            message: msg,
            type: "success",
        });
        setIsModalOpen(true);
    };

    const showError = (titleMsg, message) => {
        setModalConfig({
            title: titleMsg,
            message: message,
            type: "error",
        });
        setIsModalOpen(true);
    };

    // Load initial data on mount
    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setUserInfo(JSON.parse(storedUser));
        }

        fetchTasks();
    }, [fetchTasks]);

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Handle form submission and API call
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setApiMessage({ type: '', text: '' });

        // Combine date and time into the required ISO format
        const preferredDateTime = new Date(`${formData.preferredDate}T${formData.preferredTime}:00.000Z`);


        const {
            taskType, preferredDate, slotId, pickupAddress, pickupLatitude,
            pickupLongitude, dropCentreId, dropAddress, dropLatitude,
            dropLongitude, priority, description, assignedTo, pickupClientId
        } = formData;

        const finalPayload = {
            taskType: taskType,
            preferredDate: preferredDate,
            slotId: parseInt(slotId, 10),
            pickupClientId: pickupClientId,
            priority: priority,
            description: description,
            createdById: userInfo?.id,
            pickupAddress: pickupAddress,
            pickupLatitude: String(pickupLatitude),
            pickupLongitude: String(pickupLongitude),
            dropCentreId: dropCentreId,
            dropAddress: dropAddress,
            dropLatitude: String(dropLatitude),
            dropLongitude: String(dropLongitude),
            assignedTo: parseInt(assignedTo),
            // createdByType: "OPERATION",
            createdBy: "OPERATION",
        };
        if (slotId == null || slotId == "" || slotId == NaN) {
            showError("Sorry!", "Slot time is required!");
            setIsSubmitting(false);
            return
        }
        console.log('submit', finalPayload)

        try {
            // --- LOGIC TO SWITCH BETWEEN CREATE AND UPDATE ---
            if (editingTask) {
                // ** UPDATE MODE **
                const updatePayload = {
                    ...finalPayload,
                    taskId: editingTask.id // 
                };

                const response = await updateOperationTask(updatePayload);

                if (response.status === 1) {
                    setTaskList(prevTasks =>
                        prevTasks.map(task =>
                            task.id === editingTask.id ? response.data : task
                        )
                    );
                    // alert('Task updated successfully!');
                    showSuccess(`Task updated successfully!`);
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                } else {
                    // alert(`Failed to update task: ${response.message || 'Unknown error'}`);
                    showError("Sorry!", "Failed to update task");
                    setIsSubmitting(false);
                }

            } else {
                const response = await creatTask(finalPayload);

                if (response.status === 1) {
                    const newTaskForState = {
                        ...finalPayload,
                        ...response.data, // This will add/overwrite keys like `id`, `status`, etc.
                    };
                    setTaskList(prev => [...prev, newTaskForState]);
                    showSuccess(`Task scheduled saved successfully!`);

                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                } else {
                    showError("API Error", "Operation failed. Server returned status 0.");
                    setIsSubmitting(false);
                }
            }

            // Reset form and clear the editing state after successful submission
            setFormData(initialFormState);
            setEditingTask(null);

        } catch (error) {
            console.error("An error occurred:", error);
            setApiMessage({ type: 'error', text: 'Error communicating with the server.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    const onEdit = (task) => {
        setEditingTask(task); // Update the state
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
        <div className="bg-gray-50 min-h-screen">
            <div className="main-wrap">
                <div className="container">
                    <div className="title">
                        <h4>Logistics Task Scheduler</h4>
                    </div>

                    {/* API Message Display */}
                    {apiMessage.text && (
                        <div className={`p-3 mb-6 rounded ${apiMessage.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                            {apiMessage.text}
                        </div>
                    )}

                    {/* Task Form */}
                    <TaskForm
                        formData={formData}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                        setFormData={setFormData}
                        initialData={editingTask}
                    />

                    {/* Task List Table */}
                    <TaskList
                        showAlerts={{ showSuccess, showError }}
                        data={taskList}
                        isLoading={isLoading}
                        onEdit={onEdit}
                    />

                    <Modal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        title={modalConfig.title}
                        message={modalConfig.message}
                        type={modalConfig.type}
                    />
                </div>
            </div>
        </div>

    );
}

// =================================================================
// TASK FORM COMPONENT
// =================================================================

const TaskForm = ({ formData, handleChange, handleSubmit, isSubmitting, setFormData, initialData }) => {
    const [isMapOpen, setIsMapOpen] = useState(false);
    const [mapTarget, setMapTarget] = useState(null); // 'pickup' or 'drop'

    const [slotList, setSlotList] = useState([]);
    const [centreList, setCentretList] = useState([]);
    const [clientList, setClienttList] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [selectedClientObj, setSelectedClientObj] = useState(null);
    const [selectedDropAddrObj, setSelectedDropAddrObj] = useState(null);


    const handleCloseMap = () => setIsMapOpen(false);

    // ✅ Function to open map for a specific target (Pickup or Drop)
    const handleOpenMap = (target) => {
        setMapTarget(target);
        setIsMapOpen(true);
    };

    const fetchTasks = useCallback(async () => {
        // setIsLoading(true);
        // setApiMessage({ type: '', text: '' });

        try {
            const response = await getAllSlot();
            if (response.status === 1) {
                setSlotList(response.data.filter(slot => (slot.status == "ACTIVE")));
            } else {
                setSlotList([]);
            }
        } catch (error) {
            alert({ type: 'error', text: 'Network error occurred while fetching data.' });
        }
        try {
            const response = await getAllCentre();
            if (response.status === 1) {
                setCentretList(response.data.filter(centre => centre.status == "ACTIVE"));
            } else {
                setCentretList([]);
            }
        } catch (error) {
            alert({ type: 'error', text: 'Network error occurred while fetching data.' });
        }
        try {
            const response = await getAllClients();
            if (response.status === 1) {
                // setClienttList(response.data.filter(item => item.status == "ACTIVE"));
                setClienttList(response.data.filter(item => item.status === "ACTIVE"));
            } else {
                alert({ type: 'error', text: 'Failed to fetch task list.' });
            }
        } catch (error) {
            alert({ type: 'error', text: 'Network error occurred while fetching data.' });
        }
        try {
            const response = await getAllEmployees();
            if (response.status === 1) {
                setEmployeeList(response.data.filter(item => item.userType == "LOGISTIC"));
            } else {
                alert({ type: 'error', text: 'Failed to fetch task list.' });
            }
        } catch (error) {
            alert({ type: 'error', text: 'Network error occurred while fetching data.' });
        } finally {
            // setIsLoading(false);
        }
    }, []);

    // Load initial data on mount
    useEffect(() => {
        fetchTasks();
    }, [fetchTasks]);



    const handleClientChange = (e) => {
        const selectedId = Number(e.target.value); // Convert to number if IDs are numeric
        const client = clientList.find(c => c.id === selectedId) || null;
        setSelectedClientObj(client);
        setFormData(prev => ({
            ...prev,
            pickupClientId: selectedId
        }));
    };

    const handleDropChange = (e) => {
        const selectedId = Number(e.target.value); // Convert to number if IDs are numeric
        const centre = centreList.find(c => c.id === selectedId) || null;
        setSelectedDropAddrObj(centre);
        setFormData(prev => ({
            ...prev,
            dropCentreId: selectedId
        }));
    };


    const selectedClient = {
        primaryLogistic: selectedClientObj?.primaryLogistic,
        secondaryLogistic: selectedClientObj?.secondaryLogistic,
    };


    useEffect(() => {
        if (initialData && initialData.pickupClientId) {
            const client = clientList.find(c => c.id === initialData.pickupClientId) || null;
            setSelectedClientObj(client);
        }
    }, [initialData, clientList]);

    // ✅ Callback from MapModal to save coordinates
    const handleSaveLatLong = (lat, lng) => {
        setFormData((prev) => {
            if (mapTarget === 'pickup') {
                return { ...prev, pickupLatitude: lat, pickupLongitude: lng };
            } else if (mapTarget === 'drop') {
                return { ...prev, dropLatitude: lat, dropLongitude: lng };
            }
            return prev;
        });
        handleCloseMap(); // Close map after selection
    };

    useEffect(() => {
        if (selectedClientObj) {
            setFormData(prev => ({
                ...prev,
                pickupAddress: selectedClientObj.address || ''
            }));
        }
    }, [selectedClientObj, setFormData]);

    useEffect(() => {
        if (selectedDropAddrObj) {
            setFormData(prev => ({
                ...prev,
                dropAddress: selectedDropAddrObj.address || ''
            }));
        }
    }, [selectedDropAddrObj, setFormData]);


    // Determine initial coordinates to show in the map modal based on the current target
    const initialLat = mapTarget === 'pickup' ? formData.pickupLatitude : formData.dropLatitude;
    const initialLng = mapTarget === 'pickup' ? formData.pickupLongitude : formData.dropLongitude;

    const isEditMode = !!formData.id;


    useEffect(() => {
        if (initialData && initialData.id) {
            // Map the API data structure to the form's state structure
            setFormData({
                taskId: initialData.id,
                taskType: initialData.taskType,
                preferredDate: initialData.preferredDate ? initialData.preferredDate.split('T')[0] : '', // Format date for input
                slotId: initialData.slotId || '',
                pickupClientId: initialData.pickupClientId || '',
                pickupAddress: initialData.pickupAddress || "",
                pickupLatitude: initialData.pickupLatitude || '',
                pickupLongitude: initialData.pickupLongitude || '',
                dropCentreId: initialData.dropCentreId || '',
                dropAddress: initialData.dropAddress || '',
                dropLatitude: initialData.dropLatitude || '',
                dropLongitude: initialData.dropLongitude || '',
                assignedTo: initialData.assignedTo || '',
                priority: initialData.priority || 'NORMAL',
                description: initialData.description || '',
                // Add any other fields you need to populate
            });
        }
    }, [initialData, setFormData]);


    const InputField1 = ({ label, name, value, onChange, ...props }) => {
        return (
            <div className="mb-4">
                <label htmlFor={name} className="block text-sm font-medium text-gray-700">
                    {label}
                    {props.required && <span className="text-red-500 ml-1">*</span>}
                </label>
                <input
                    type="text"
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    // CRITICAL: Spread all collected props onto the native input element
                    {...props}
                    className={`mt-1 block w-full rounded-md shadow-sm p-2 
          ${props.readOnly ? 'bg-gray-100 text-gray-600 cursor-default' : 'border-gray-300 focus:ring-green-500 focus:border-green-500'}
        `}
                />
            </div>
        );
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-xl mb-8 border-t-4 border-green-600">
            <h2 className="text-2xl font-semibold mb-4 text-green-700">
                {isEditMode ? `Edit Task #${formData.id}` : 'Schedule New Pickup/Delivery Task'}
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6">

                {/* ... (Existing form fields: Task Type, Date, Time, Slot ID) ... */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <InputField1 label="Task Type" name="taskType" readOnly  value={formData.taskType} onChange={handleChange} />
                    <InputField label="Preferred Date" name="preferredDate" type="date" value={formData.preferredDate} onChange={handleChange} required />
                    {/* <InputField label="Preferred Time" name="preferredTime" type="time" value={formData.preferredTime} onChange={handleChange} required /> */}
                    {/* Time Slot Dropdown - Now populated from API data */}
                    <SelectField
                        label="Time Slot"
                        name="slotId"
                        value={formData.slotId}
                        onChange={handleChange}
                        required
                        options={slotList.map(slot => ({
                            value: slot.id,
                            label: `${slot.startTime || '??:??'} - ${slot.endTime || '??:??'}`
                        }))}
                    />
                </div>

                {/* --- PICKUP DETAILS --- */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4 border-t pt-3 md:pt-4 items-start lg:items-end">
                    <h3 className="text-lg font-semibold text-green-600 col-span-full">Pickup Details</h3>

                    <Select
                        id="pickupClientId"
                        name="pickupClientId"
                        value={
                            clientList
                                ? clientList
                                    .map((client) => ({
                                        value: client.id,
                                        label: client.clientName,
                                    }))
                                    .find((option) => option.value === formData.pickupClientId) || null
                                : null
                        }
                        onChange={(selectedOption) =>
                            handleClientChange({
                                target: {
                                    name: "pickupClientId",
                                    value: selectedOption?.value || "",
                                },
                            })
                        }
                        options={[
                            { value: "", label: "-- Select Client --" },
                            ...clientList.map((client) => ({
                                value: client.id,
                                label: client.clientName,
                            })),
                        ]}
                        placeholder="-- Select Client --"
                        isSearchable
                        className="mt-1"
                        styles={{
                            control: (base) => ({
                                ...base,
                                borderColor: "#d1d5db",
                                borderRadius: "0.375rem",
                                boxShadow: "none",
                                "&:hover": { borderColor: "#16a34a" },
                            }),
                        }}
                    />


                    <InputField label="Pickup Address" name="pickupAddress" value={formData.pickupAddress} onChange={handleChange} className="sm:col-span-2 lg:col-span-2" required />

                    {/* Lat/Lng Fields */}
                    <InputField label="Pickup Latitude" name="pickupLatitude" type="number" value={formData.pickupLatitude} onChange={handleChange} required />
                    <InputField label="Pickup Longitude" name="pickupLongitude" type="number" value={formData.pickupLongitude} onChange={handleChange} required />

                    {/* ✅ Map Button for Pickup */}
                    <button
                        type="button"
                        onClick={() => handleOpenMap('pickup')} // Specify target
                        className="h-10 px-3 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition duration-150 font-medium"
                    >
                        📍 Select Map
                    </button>
                </div>

                {/* --- DROP DETAILS --- */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 border-t pt-4 items-end">
                    <h3 className="text-lg font-semibold text-green-600 col-span-full">Drop Details</h3>

                    {/* <SelectField label="Drop Centre" name="dropCentreId" value={formData.dropCentreId} onChange={handleChange} required /> */}
                    <SelectField
                        label="Drop Centre"
                        name="dropCentreId"
                        value={formData.dropCentreId}
                        onChange={handleDropChange} // Ensure you use the local handler (handleInputChange)
                        required
                        options={[
                            // 1. ✅ Add the default "Select" option
                            {
                                value: "", // Value should be empty to force selection
                                label: "-- Select Drop Centre --",
                                disabled: true // Prevent re-selection
                            },

                            // 2. Spread the options generated from the centreList map
                            ...centreList.map(centre => ({
                                // NOTE: Adjust keys if necessary
                                value: centre.id,
                                label: centre.centreName
                            }))
                        ]}
                    />
                    <InputField label="Drop Address" name="dropAddress" value={formData.dropAddress} onChange={handleChange} className="sm:col-span-2 lg:col-span-2" required />

                    {/* Lat/Lng Fields */}
                    <InputField label="Drop Latitude" name="dropLatitude" type="number" value={formData.dropLatitude} onChange={handleChange} required />
                    <InputField label="Drop Longitude" name="dropLongitude" type="number" value={formData.dropLongitude} onChange={handleChange} required />

                    {/* ✅ Map Button for Drop */}
                    <button
                        type="button"
                        onClick={() => handleOpenMap('drop')} // Specify target
                        className="h-10 px-3 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition duration-150 font-medium"
                    >
                        📍 Select Map
                    </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t pt-4">
                    {/* <SelectField label="Assign To" name="assignedTo" value={formData.assignedTo} onChange={handleChange} required /> */}
                    {/* <SelectField
                        label="Assign To"
                        name="assignedTo"
                        value={formData.assignedTo}
                        onChange={handleChange} // Ensure you use the local handler (handleInputChange)
                        required
                        options={[
                            {
                                value: "",
                                label: "-- Select Employee --",
                                disabled: true
                            },

                            ...employeeList.map(employee => ({
                                value: employee.id,
                                label: employee.employeeName
                            }))
                        ]}
                    /> */}
                    <div>
                        <label
                            htmlFor="assignedTo"
                            className="block text-sm font-medium text-gray-700 mb-1"
                        >
                            Assign to
                        </label>

                        {(() => {
                            // ✅ Sort employees so primary & secondary logistics come first
                            const sortedEmployees = [...employeeList].sort((a, b) => {
                                const priority = (emp) => {
                                    if (emp.id == selectedClient.primaryLogistic) return 1;
                                    if (emp.id == selectedClient.secondaryLogistic) return 2;
                                    return 3;
                                };
                                return priority(a) - priority(b);
                            });

                            // Map sorted employees to react-select options
                            const employeeOptions = sortedEmployees.map((item) => {
                                const isPrimary = item.id == selectedClient.primaryLogistic;
                                const isSecondary = item.id == selectedClient.secondaryLogistic;

                                return {
                                    value: item.id,
                                    label: `${item.employeeName}${isPrimary ? " (Primary Logistic)" : isSecondary ? " (Secondary Logistic)" : ""
                                        }`,
                                    meta: { isPrimary, isSecondary },
                                };
                            });

                            return (
                                <Select
                                    id="assignedTo"
                                    name="assignedTo"
                                    value={employeeOptions.find((option) => option.value == formData.assignedTo) || null}
                                    onChange={(selectedOption) =>
                                        handleChange({
                                            target: {
                                                name: "assignedTo",
                                                value: selectedOption?.value || "",
                                            },
                                        })
                                    }
                                    options={employeeOptions}
                                    placeholder="-Select Employee-"
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            borderColor: "#d1d5db",
                                            borderRadius: "0.375rem",
                                            boxShadow: "none",
                                            "&:hover": { borderColor: "#16a34a" },
                                        }),
                                        option: (base, { data, isFocused, isSelected }) => ({
                                            ...base,
                                            fontWeight: data.meta.isPrimary || data.meta.isSecondary ? "bold" : "normal",
                                            color: data.meta.isPrimary
                                                ? "green"
                                                : data.meta.isSecondary
                                                    ? "#0ea5e9"
                                                    : "black",
                                            backgroundColor: isFocused ? "#f0fdf4" : "white",
                                        }),
                                    }}
                                />
                            );
                        })()}
                    </div>
                    <SelectField label="Priority" name="priority" value={formData.priority} onChange={handleChange} options={[{ value: 'HIGH', label: 'HIGH' }, { value: 'NORMAL', label: 'NORMAL' }]} required />
                    <div className="md:col-span-3">
                        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="description">Description</label>
                        <textarea id="description" name="description" value={formData.description} onChange={handleChange} rows="3" className="w-full border border-gray-300 p-2 rounded-md focus:ring-green-500 focus:border-green-500"></textarea>
                    </div>
                </div>

                {/* Submit Button */}
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full py-3 px-4 rounded-md text-white font-semibold tracking-wider transition duration-150 ${isSubmitting ? 'bg-green-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
                        }`}
                >
                    {isSubmitting
                        ? (isEditMode ? 'UPDATING...' : 'SCHEDULING...')
                        : (isEditMode ? 'UPDATE TASK' : 'SCHEDULE TASK')
                    }
                </button>
            </form>

            {/* Map Modal */}
            {/* Pass dynamic initial coords based on the target */}
            <MapModal
                isOpen={isMapOpen}
                onClose={handleCloseMap}
                initialLat={initialLat}
                initialLng={initialLng}
                onSaveLatLong={handleSaveLatLong}
            />
        </div>
    );
};

// --- Form Helper Components ---
const InputField = ({ label, name, type = "text", value, onChange, required = false, className = '' }) => (
    <div className={className}>
        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor={name}>{label}</label>
        <input
            type={type}
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            className="w-full border border-gray-300 p-2 rounded-md focus:ring-green-500 focus:border-green-500"
        />
    </div>
);

const SelectField = ({ label, name, value, onChange, options, required = false }) => (
    <div>
        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor={name}>{label}</label>
        <select
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            className="w-full border border-gray-300 p-2 rounded-md focus:ring-green-500 focus:border-green-500 bg-white"
        >
            {options?.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
            ))}
        </select>
    </div>
);

// =================================================================
// TASK LIST COMPONENT (The Table)
// =================================================================

const TaskList = ({ data, isLoading, onEdit, handleAction }) => {

    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const [taskToCancel, setTaskToCancel] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [taskData, setTaskData] = useState({});
    // --- Handlers ---
    const storedUser = localStorage.getItem('user');
    const userInfo = JSON.parse(storedUser)

    const handleOpenCancelModal = (taskItem) => {
        setTaskToCancel({
            taskId: taskItem.id,
            userId: userInfo.id // Or get the current logged-in user's ID
        });
        setIsCancelModalOpen(true);
    };

    // 2. Closes the modal
    const handleCloseCancelModal = () => {
        setIsCancelModalOpen(false);
        setTaskToCancel(null); // Clear the task data
    };

    // 3. Runs after a successful API call
    const handleCancelSuccess = (message) => {
        // 🚨 IMPORTANT: Trigger a refresh of the task list here!
        // fetchTaskList();
        // setApiMessage({ type: 'success', text: message });
        console.log("Message 111: ", message)
    };

    if (isLoading && data.length === 0) {
        return <p className="p-4 text-center text-green-600 font-medium">Loading tasks...</p>;
    }

    if (!data || data.length === 0) {
        return <p className="p-4 text-center text-gray-500">No pending tasks found.</p>;
    }

    const columns = ["ID", "Type", "Date/Time", "Client ID", "Assigned To", "Priority", "Status", "Actions"];

    // Helper to render status badge
    const StatusBadge = ({ status }) => {
        const statusText = status?.toUpperCase() || 'UNKNOWN';
        let colorClass;

        if (statusText === 'PENDING') colorClass = 'bg-yellow-100 text-yellow-800';
        else if (statusText === 'COMPLETED') colorClass = 'bg-green-100 text-green-800';
        else if (statusText === 'HIGH') colorClass = 'bg-red-100 text-red-800';
        else colorClass = 'bg-gray-100 text-gray-800';

        return (
            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${colorClass}`}>
                {statusText}
            </span>
        );
    };



    return (
        <div className="bg-white p-6 rounded-lg shadow-xl border-t-4 border-green-600">
            <h2 className="text-2xl font-semibold mb-4 text-green-700">Scheduled Tasks ({data.length})</h2>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-green-50">
                        <tr>
                            {columns?.map(col => (
                                <th key={col} className="px-6 py-3 text-left text-xs font-medium text-green-800 uppercase tracking-wider">
                                    {col}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {data?.map((item) => {
                            const { dateStr, timeStr } = formatDateTime(item?.preferredDate || 'N/A');
                            return (
                                <tr key={item.id} className="hover:bg-gray-50">
                                    {/* Data Cells */}
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.id}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item?.taskType}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{dateStr} @ {timeStr}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item?.pickupClient?.clientName}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item?.assignedUser?.employeeName || "Pending..."}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm"><StatusBadge status={item?.priority} /></td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm"><StatusBadge status={item?.status} /></td>

                                    {/* Actions Cell */}
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-1">
                                        <button
                                            onClick={() => {
                                                setTaskData(item);
                                                setIsModalOpen(true);
                                            }}
                                            className="text-white font-sm py-2 px-3 rounded text-sm view_btn"
                                        >
                                            View
                                        </button>

                                        <button
                                            onClick={() => handleOpenCancelModal(item)}
                                            className={`text-white font-sm py-2 px-3 rounded text-sm cancel_btn ${item.status === "CANCELLED" ? "opacity-50 cursor-not-allowed" : ""
                                                }`}
                                            disabled={item.status === "CANCELLED"}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            onClick={() => onEdit(item)}
                                            className={`text-white font-sm py-2 px-3 rounded text-sm theme_btn ${item.status === "CANCELLED" ? "opacity-50 cursor-not-allowed" : ""
                                                }`}
                                            disabled={item.status === "CANCELLED"}
                                        >
                                            Edit
                                        </button>
                                    </td>

                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <CancelTaskModal
                isOpen={isCancelModalOpen}
                onClose={handleCloseCancelModal}
                taskToCancel={taskToCancel} // Pass the task object containing IDs
                onSuccess={handleCancelSuccess}
            // cancelTaskApi={cancelTaskApi} // Pass the API function if you prefer
            />
            {
                isModalOpen &&
                <TaskViewModal
                    taskData={taskData}
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                />
            }


        </div>
    );
};

export default OperationTask;




